import React from 'react';

export const ModuleAccess = (module, permission) => {
    var modules = {
        'CLM': {
            'SUPADM': ['VW', 'ED', 'AT', 'HI', 'PC', 'PRD', 'HC', 'CSM', 'FAX', 'ENC', 'REF', 'EXP', 'ACC', 'PPB'],
            'RCMADM': ['VW', 'ED', 'AT', 'HI', 'PC', 'PRD', 'HC', 'CSM', 'FAX', 'ENC', 'REF', 'EXP', 'ACC'],
            'RCMCEADM': ['VW', 'ED', 'AT', 'PC', 'FAX', 'ENC', 'REF', 'EXP', 'ACC', 'PPB'],
            'RCMHD': ['VW', 'ED', 'AT', 'HI', 'PC', 'PRD', 'HC', 'CSM', 'FAX', 'ENC', 'REF', 'EXP', 'ACC', 'PPB'],
            'RCMCEV': ['VW', 'AT', 'PC', 'FAX', 'ENC', 'REF', 'EXP']
        },
        "DB":{
    'SUPADM': [''],
    "RCMADM":['']

        },
        'PRD': { 'SUPADM': ['VW', 'ED', 'PPC', 'EXP'], 'RCMADM': ['VW', 'ED', 'PPC', 'EXP'], 'RCMHD': ['VW', 'EXP', 'PPC'] },
        'FAX': { 'SUPADM': ['VW', 'ED', 'EXP'], 'RCMADM': ['VW', 'EXP'], 'RCMHD': ['VW', 'EXP'] },
        'SL': { 'SUPADM': ['VW', 'ED', 'EXP'], 'RCMADM': ['VW', 'ED', 'EXP'], 'RCMHD': ['VW', 'EXP'] },
        'CON': { 'SUPADM': ['VW', 'ED', 'ADD', 'EXP'], 'RCMADM': ['VW', 'ED', 'ADD', 'EXP'], 'RCMHD': ['VW', 'ED', 'EXP', 'ADD'] },
        'INV': { 'SUPADM': ['VW', 'ED', 'MIG', 'EXP', 'INVD'], 'RCMADM': ['VW', 'ED', 'MIG', 'EXP', 'INVD'], 'RCMCEADM': ['VW', 'EXP', 'INVD'], 'RCMHD': ['VW', 'EXP', 'INVD'], 'RCMCEV': ['VW', 'EXP', 'INVD'] },
        'TB': { 'SUPADM': ['VW', 'ED'], 'RCMADM': ['VW'], 'RCMHD': ['VW'] }
    };

    const { access_token } =
        JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    let userRoles = [];
    if (access_token) {
        let jwtData = access_token.split('.')[1]
        let decodedJwtJsonData = window.atob(jwtData)
        let decodedJwtData = JSON.parse(decodedJwtJsonData)
        userRoles = decodedJwtData['roles'];
    }

    //console.log(module);
    var roles = modules[module];
    //console.log(roles);
    var permissions = [];
    if (Array.isArray(userRoles)) {
        for (var i = 0; i < userRoles.length; i++) {
            var userRole = userRoles[i];
            //console.log(userRole);
            var userper = roles[userRole];
            //console.log(userper);
            permissions = permissions.concat(userper);
        }
    }
    else {
        var userper = roles[userRoles];
        if (userper)
            permissions = permissions.concat(userper);
    }

    //console.log(permissions);
    if (!permission)
        return permissions.length > 0;
    return permissions.indexOf(permission) != -1;
}